<template>
  <div class="info-box">
    <v-title title="Endorsement Type"></v-title>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <el-row
        class="row-bg"
        :gutter="20"
        justify="space-around">

        <v-row-col
          :same="true"
          :same-number="12">
          <div class="form-item ">
            <span>Endorsement Effective Date</span>
            <el-form-item prop="endorsement_effective_date">
              <v-date-picker
                v-model="formData.endorsement_effective_date"
                :disabled="is_effective"
                @change="handlerComputed"
              ></v-date-picker>
            </el-form-item>
          </div>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div
            class="form-item">
            <el-form-item>
              <v-checkbox-group
                v-model="formData.endorsement_type"
                :list="
                  endorsementType"
              ></v-checkbox-group>
            </el-form-item>
          </div>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="form-item">
            <span>Notes</span>
            <el-form-item prop="notes">
              <v-input
                v-model="formData.notes"
                type="textarea"
                :rows="4"></v-input>
            </el-form-item>
          </div>
        </v-row-col>

      </el-row>

      <el-row
        class="row-bg flex-inline"
        :gutter="20"
        justify="space-around">
        <v-row-col>
          <v-title title="Endorsement Premium"></v-title>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Contents</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_contents_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_contents_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Business interruption Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_business_interruption_insurance_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_business_interruption_insurance_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Money Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_money_insurance_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_money_insurance_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Fidelity Guarantee Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_fidelity_guarantee_insurance_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_fidelity_guarantee_insurance_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Personal Accident Assault Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_personal_accident_assault_insurance_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_personal_accident_assault_insurance_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Public Liability Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_public_liability_insurance_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_public_liability_insurance_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Employees' Compensation Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_employees_compensation_insurance_premium"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.original_employees_compensation_insurance_ia_levy_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="">EC Levy</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_ec"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Original Gross Premium</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.original_ia_mib_ec"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="hr-inline"></div>
        </v-row-col>
      </el-row>
      <el-row
        class="row-bg flex-inline"
        :gutter="20"
        justify="space-around">
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span >Contents</span>
              <el-form-item prop="base_premium">
                <v-input
                  v-model.number="formData.contents_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerEdit"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>
              <el-form-item prop="client_discount">
                <el-form-item >
                  <div class="flex-aligin flex">
                    <v-input
                      v-model.number="formData.contents_ia_levy_vl"
                      prepend="HKD"
                      :disabled="formData.is_contents_ia_levy_vl==0"
                      @change="handlerComputed"
                    />
                    <v-checkbox
                      v-model.number="formData.is_contents_ia_levy_vl"
                      @change="handlerComputed"></v-checkbox>
                  </div>
                </el-form-item>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span >Business Interruption Insurance</span>
              <el-form-item prop="loading">
                <v-input
                  v-model.number="formData.business_interruption_insurance_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerComputed"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>

              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.business_interruption_insurance_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_business_interruption_insurance_ia_levy_vl==0"
                    @change="handlerComputed"
                  />
                  <v-checkbox
                    v-model.number="formData.is_business_interruption_insurance_ia_levy_vl"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span >Money Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.money_insurance_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerEdit"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>

              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.money_insurance_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_money_insurance_ia_levy_vl==0"
                    @change="handlerComputed"
                  />
                  <v-checkbox
                    v-model.number="formData.is_money_insurance_ia_levy_vl"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span >Fidelity Guarantee Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.fidelity_guarantee_insurance_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerEdit"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>

              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.fidelity_guarantee_insurance_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_fidelity_guarantee_insurance_ia_levy_vl==0"
                    @change="handlerComputed"
                  />
                  <v-checkbox
                    v-model.number="formData.is_fidelity_guarantee_insurance_ia_levy_vl"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span >Personal Accident Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.personal_accident_assault_insurance_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerEdit"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>

              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.personal_accident_assault_insurance_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_personal_accident_assault_insurance_ia_levy_vl==0"
                    @change="handlerComputed"
                  />
                  <v-checkbox
                    v-model.number="formData.is_personal_accident_assault_insurance_ia_levy_vl"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span >Public Liability Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.public_liability_insurance_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerEdit"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>

              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.public_liability_insurance_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_public_liability_insurance_ia_levy_vl==0"
                    @change="handlerComputed"
                  />
                  <v-checkbox
                    v-model.number="formData.is_public_liability_insurance_ia_levy_vl"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Employees' Compensation Insurance</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.employees_compensation_insurance_premium"
                  prepend="HKD"
                  type="number"
                  @change="handlerEdit"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>IA Levy</span>

              <el-form-item >
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number="formData.employees_compensation_insurance_ia_levy_vl"
                    prepend="HKD"
                    :disabled="formData.is_employees_compensation_insurance_ia_levy_vl==0"
                    @change="handlerComputed"
                  />
                  <v-checkbox
                    v-model.number="formData.is_employees_compensation_insurance_ia_levy_vl"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>EC Levy</span>
              <el-form-item>
                <div class="flex-aligin flex">
                  <v-input
                    v-model.number= "formData.ec_levy_vl"
                    prepend="HKD"
                    type="number"
                    disabled
                  />
                  <v-checkbox
                    v-model="formData.is_ec_levy"
                    @change="handlerComputed"></v-checkbox>
                </div>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Total New Premium</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.total_premium"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement Effective Date</span>
              <el-form-item>
                <v-date-picker
                  v-model="formData.endorsement_effective_date"
                  disabled></v-date-picker>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Gross Premium Difference</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.gross_premium_difference"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Gross Premium Difference without  Levy</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.basic_premium_difference"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement IA Levy</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.endorsement_ia_mib_ec"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement EC Levy</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.endorsement_ec"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="hr-inline"></div>
        </v-row-col>
      </el-row>
      <el-row
        class="row-bg flex-inline"
        :gutter="20"
        justify="space-around">
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Special Discount %</span>
              <el-form-item prop="base_premium">
                <v-input
                  v-model.number="formData.special_discount"
                  append="%"
                  @change="handlerComputed"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Special Discount Amount</span>
              <el-form-item>
                <v-input
                  v-model="showData.special_discount_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Premium Difference</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.premium_difference"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">IA Levy and EC Levy</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.endorsement_ia_mib_ec"
                  disabled
                  prepend="HKD"/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Handling Charge</span>
              <el-form-item>
                <v-input
                  v-model.number= "formData.handing_charge"
                  prepend="HKD"
                  @change="handlerComputed"
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Endorsement Total Payable</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.endorsement_total_payable"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
        <v-row-col
          :same="true"
          :same-number="24">
          <div class="hr-inline"></div>
        </v-row-col>
      </el-row>
      <el-row
        class="row-bg flex-inline"
        :gutter="30"
        justify="space-around">
        <v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span>Net %</span>
              <el-form-item prop="base_premium">
                <v-input
                  v-model.number="formData.net"
                  append="%"
                  @change="handlerComputed"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Net</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.net_vl"
                  prepend="HKD"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Net Comm.$</span>
              <el-form-item>
                <v-input
                  v-model.number= "showData.net_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Insurer Net %</span>
              <el-form-item>
                <v-input
                  v-model="showData.insurer_net"
                  append="%"
                  disabled
                />
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Insurer Net</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.insurer_net_vl"
                  disabled
                  prepend="HKD"/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Insurer Net Comm.$</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.insurer_net_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">Referrer Comm.</span>
              <el-form-item >
                <v-input
                  v-model.number="showData.referrer_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
          <v-row-col
            :same="true"
            :same-number="24">
            <div class="form-item ">
              <span class="disable-span">RM Comm.</span>
              <el-form-item>
                <v-input
                  v-model.number="showData.owner_commission_vl"
                  prepend="HKD"
                  disabled/>
              </el-form-item>
            </div>
          </v-row-col>
        </v-row-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {computedEndorsement} from '@api/endorsement'
import {mapState,mapActions} from 'vuex'

export default {
  name: 'endorsement',
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    clientType:{
      type: Number,
      default: 1
    }
  },

  data(){
    return{
      is_self:true,
      is_created:false,
      showData:{
        endorsement_ec:'',
        original_ec:'',
        ec_levy_vl:'',
        original_ia_mib_ec:'',
        original_premium:'',
        original_gross_premium:'',
        gross_premium_difference:'',
        ncd:'',
        mib_vl:'',
        ia_levy_vl: '',
        amount_received: '',
        gross_premium:'',
        total_premium:'',
        net_vl:'',
        owner_commission_vl:'',
        insurer_net_commission_vl:'',
        insurer_net_vl:'',
        net_commission_vl:'',
        referrer_commission_vl:'',
        insurer_net: '',
        basic_premium:'',
        endorsement_total_payable:'',
        premium_difference:'',
        basic_premium_difference:'',
        endorsement_ia_mib_ec:'',
        is_special:1,
        special_discount_vl:'',

        original_contents_premium:'',
        original_contents_ia_levy_vl:'',

        original_business_interruption_insurance_premium:'',
        original_business_interruption_insurance_ia_levy_vl:'',

        original_money_insurance_premium:'',
        original_money_insurance_ia_levy_vl:'',

        original_fidelity_guarantee_insurance_premium:'',
        original_fidelity_guarantee_insurance_ia_levy_vl:'',

        original_personal_accident_assault_insurance_premium:'',
        original_personal_accident_assault_insurance_ia_levy_vl:'',

        original_public_liability_insurance_premium:'',
        original_public_liability_insurance_ia_levy_vl:'',

        original_employees_compensation_insurance_premium:'',
        original_employees_compensation_insurance_ia_levy_vl:'',

      },
      formData:{
        ncd:'',
        handing_charge:'',
        base_premium:'',
        loading:'',
        client_discount:'',
        additional_premium:'',
        ia_levy:'',
        is_ia_levy_vl:0,
        ia_levy_vl:0,
        ec_levy_vl:'',
        is_special:1,
        special_discount:'',
        net:'',
        endorsement_effective_date:'',
        endorsement_type:[],
        notes:'',
        is_edit:0,
        contents_premium:'',
        is_contents_ia_levy_vl:'',
        contents_ia_levy_vl:'',
        business_interruption_insurance_premium:'',
        is_business_interruption_insurance_ia_levy_vl:'',
        business_interruption_insurance_ia_levy_vl:'',
        money_insurance_premium:'',
        is_money_insurance_ia_levy_vl:'',
        money_insurance_ia_levy_vl:'',
        fidelity_guarantee_insurance_premium:'',
        is_fidelity_guarantee_insurance_ia_levy_vl:'',
        fidelity_guarantee_insurance_ia_levy_vl:'',
        personal_accident_assault_insurance_premium:'',
        is_personal_accident_assault_insurance_ia_levy_vl:'',
        personal_accident_assault_insurance_ia_levy_vl:'',
        public_liability_insurance_premium:'',
        is_public_liability_insurance_ia_levy_vl:'',
        public_liability_insurance_ia_levy_vl:'',
        employees_compensation_insurance_premium:'',
        is_employees_compensation_insurance_ia_levy_vl:'',
        employees_compensation_insurance_ia_levy_vl:''
      },
    }
  },
  computed:{
    ...mapState('quotation', ['quoteInformationForm','ncd','ncdList']),
    order_no(){
      let {order_no=''} = this.quoteInformationForm
      return order_no
    },
    productId(){
      return this.form.product_id
    },
    productMotor(){
      return this.productId == 10
    },
    showEcPercent(){
      return this.productId==13
    },
    showEcHKD(){
      return [13,14,15,16,17,18].includes(this.productId)
    },
    endorsementType()
    {
      let typesArr = this.globalOptions.endorsement_type
      let arr = []
      typesArr.filter(item=>{
        if(item.product_id == this.productId)
          arr = item.items
      })
      return arr.length<=0?[]:arr
    },
    is_effective(){
      let {order_status} = this.quoteInformationForm||{}
      return order_status>10&&!this.$route.query.isEndorsement

    },

  },
  watch:{
    ncd:{
      immediate:true,
      handler(val,old){
        this.formData.ncd = val
        if(old>=0&&!this.is_self)
        {
          this.is_self = false
          this.handlerComputed()
        }
      }
    }
  },
  created() {
    this.handlerInit()
  },
  methods:{
    ...mapActions('quotation', ['setNcd']),
    ...mapActions('coverage', ['setCoverage']),
    handlerEdit(){
      let params ={
        contents:{
          premium:this.formData.contents_premium
        },
        business_interruption_insurance:{
          premium:this.formData.business_interruption_insurance_premium
        },
        money_insurance:{
          premium:this.formData.money_insurance_premium
        },
        fidelity_guarantee_insurance:{
          premium:this.formData.fidelity_guarantee_insurance_premium
        },
        personal_accident_assault_insurance:{
          premium:this.formData.personal_accident_assault_insurance_premium
        },
        public_liability_insurance:{
          premium:this.formData.public_liability_insurance_premium
        },
        employees_compensation_insurance:{
          premium:this.formData.employees_compensation_insurance_premium
        }
      }
      this.setCoverage(params)
      this.network().computedQuotation()
    },
    handlerInit(){
      if(this.quoteInformationForm){
        let {premium,notes,endorsement_type=[],endorsement_effective_date='',is_edit=0} = this.quoteInformationForm
        this.showData = Object.assign(this.showData,premium)
        this.formData.endorsement_type = endorsement_type
        this.formData.notes = notes
        this.formData.is_edit =is_edit
        if(is_edit)
          this.formData.endorsement_effective_date = endorsement_effective_date
        Object.keys(this.formData).some(key => {
          if (key in premium) {
            this.formData[key] = premium[key]
          }
        })

        this.is_self = true
        this.network().computedQuotation()
      }
    },
    async submitForm(formName) {
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate(valid => {
          if(valid) {
            this.$emit('getFormData', formName, this.formData)
            resolve(valid)
          } else {
            reject(valid)
          }
        })
      })
    },
    handlerChangeNcd(){
      this.is_self= false
      this.setNcd(this.formData.ncd)
    },
    handlerComputed(){
      // this.$refs.form.validate((valid, invalidFields) => {
      //   if (valid) {
      this.network().computedQuotation()
      // }else{
      // }
      // })
    },
    network() {
      return {
        computedQuotation:async ()=>{
          this.is_self= false
          let params ={...this.formData,...{order_no:this.order_no,product_id:this.form.product_id}}
          let { data } = await computedEndorsement(params)
          this.showData = data
          // let {endorsement_effective_date,handing_charge} = data
          // this.formData.endorsement_effective_date = endorsement_effective_date
          // this.formData.handing_charge = handing_charge

          Object.keys(this.formData).some(key => {
            if (key in data) {
              this.formData[key] = data[key]
            }
          })
          // if(!this.is_created){
          //   this.is_created = true
          //   Object.keys(this.showData).some(key => {
          //     if (key in data) {
          //       if(key.includes('_ia_levy_vl')){
          //         let keyName = key.split('original_')[1]
          //         if(keyName)
          //         {
          //           // let name  = keyName.split('_vl')[0]
          //           this.formData['is_'+keyName] =data[key]<=0?0:1
          //           this.formData[keyName] =data[key]
          //         }
          //
          //       }
          //
          //     }
          //   })
          //
          // }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flex-inline{
  .form-item{
    display: flex;
    margin-bottom: 16px;
    align-items: center;
    span{
      flex: 1;
    }
    .disable-span{
      color: #718096;
    }
    .el-form-item{
      flex: 2;
    }

  }
  .hr-inline{
    margin:20px 10px;
  }
}

</style>
